<!--
  BooleanInput.vue

  Form input for boolean-kind fields. Renders a single `<input
  type="checkbox">` in its own Bulma `.checkbox` label — no `ValueInput`
  wrapper, since the checkbox idiom is its own.
-->
<template>
  <label class="checkbox">
    <input type="checkbox" :checked="!!modelValue" :disabled="disabled" @change="onChange" />
    <span v-if="label" class="ml-2">{{ label }}</span>
  </label>
</template>

<script setup lang="ts">
import { type Field, parseValue } from "@auger/core/fields"

const props = withDefaults(
  defineProps<{
    modelValue?: boolean
    field: Field
    label?: string
    disabled?: boolean
  }>(),
  {
    modelValue: false,
    label: "",
    disabled: false,
  }
)

const emit = defineEmits<{
  "update:modelValue": [value: unknown]
}>()

function onChange(event: Event) {
  const checked = (event.target as HTMLInputElement).checked
  emit("update:modelValue", parseValue(props.field, checked))
}
</script>
